<template>
  <div class="container">
    <div class="text">
      视频上传中（{{ bar }}%）
    </div>
    <div class="track">
      <div
        class="bar"
        :style="{ width: `${bar}%` }"
      ></div>
    </div>
    <div
      class="cancel"
      @click="cancel"
    >
      取消
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bar: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {};
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.track {
  width: 391px;
  height: 10px;
  background-color: #e5e5e5;
  border-radius: 5px;
}
.bar {
  width: 0;
  height: 10px;
  background: #3058fe;
  border-radius: 5px;
  transition-duration: 0.3s;
}
.text {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  margin-bottom: 15px;
}
.cancel {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  margin-top: 30px;
  cursor: pointer;
  &:hover {
    border-color: #3058fe;
    color: #3058fe;
  }
}
</style>
